import React from 'react';
interface ReceiptPaymentSummaryProps {
  currency: string;
  amountReceived: number;
  totalAmount: number;
  balanceDue: number;
}
export function ReceiptPaymentSummary({
  currency,
  amountReceived,
  totalAmount,
  balanceDue
}: ReceiptPaymentSummaryProps) {
  const formatAmount = (amount: number) => {
    return `${currency} ${amount.toFixed(2)}`;
  };
  return <div className="mb-8 py-6 border-t border-b border-neutral-200" data-id="element-1088">
      <div className="max-w-md mx-auto space-y-3" data-id="element-1089">
        {/* Amount Received - Large and Bold */}
        <div className="flex justify-between items-center" data-id="element-1090">
          <span className="text-base font-semibold text-neutral-700" data-id="element-1091">
            Amount Received:
          </span>
          <span className="text-2xl font-bold text-green-600" data-id="element-1092">
            {formatAmount(amountReceived)}
          </span>
        </div>

        {/* Total Amount */}
        <div className="flex justify-between items-center" data-id="element-1093">
          <span className="text-sm font-medium text-neutral-600" data-id="element-1094">
            Total Amount:
          </span>
          <span className="text-base font-medium text-neutral-900" data-id="element-1095">
            {formatAmount(totalAmount)}
          </span>
        </div>

        {/* Balance Due */}
        <div className="flex justify-between items-center pt-2 border-t border-neutral-200" data-id="element-1096">
          <span className="text-sm font-semibold text-neutral-700" data-id="element-1097">
            Balance Due:
          </span>
          <span className="text-base font-bold text-neutral-900" data-id="element-1098">
            {formatAmount(balanceDue)}
          </span>
        </div>
      </div>
    </div>;
}